import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';

export const PageContainer = muiStyled(Box)({
  display: 'flex',
  flexDirection: 'row',
  minHeight: '100vh',
  width: '100%',
  background: '#0F1419',
  margin: 0,
  padding: 0
});

export const MainContent = muiStyled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  margin: 0,
  background: 'linear-gradient(135deg, #0F1419 0%, #111827 100%)',

  [theme.breakpoints.down('md')]: {
    padding: 0
  }
}));

export const Header = muiStyled(Box)(({ theme }) => ({
  marginBottom: '16px',
  padding: 0,
  '& h1': {
    color: '#F9FAFB',
    fontSize: '2rem',
    fontWeight: 700,
    background: 'linear-gradient(90deg, #047857 0%, #059669 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent'
  }
}));

export const Title = muiStyled('h1')({
  fontSize: '2rem',
  fontWeight: 600,
  margin: 0
});

export const TableSection = muiStyled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  padding: 0,
  margin: 0,
  width: '100%'
})); 